// extracted by mini-css-extract-plugin
export default {"popup":"LinkEdit_popup__G32Me"};